<white-label-horizontal-carousel [interval]="2000">
    <!-- Each item is a template. You can add a directive if desired. -->
    @for(item of concatSponsors(); track $index){

        <ng-template #item>
            <a
                    [href]="item?.linkUrl?.value | safe: 'url'"
                    class="flex-shrink-0 w-32 h-32 flex items-center justify-center p-2"
            >
                <img
                        [src]="item?.avatarUrl?.value"
                        [alt]="item?.title?.value"
                        class="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition ease-in-out duration-300"
                />
            </a>

        </ng-template>

    }

</white-label-horizontal-carousel>



